
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import { formatDate, learnStatus } from '../../utils/publish'
import DashboardHeader from '../../components/Dashboards/DashboardHeader.vue'
import HistorySign from '../../components/course/history-sign.vue'
import HistoryNoSign from '../../components/course/history-no-sign.vue'
import StudentInfo from '../../components/studentDeatil/student-info.vue'
import TableSign from '../../components/course/table-sign.vue'
import TableNoSign from '../../components/course/table-no-sign.vue'

@Component({
  name: 'sign',
  components: { DashboardHeader, HistorySign, HistoryNoSign, StudentInfo, TableSign, TableNoSign } 
})
export default class extends Vue {
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: string = ''
    studentCourseList:any = []
    campus_id: string = ''
    selectBaseCourse:string = ''
    campus: any = []
    employee: any = []
    employeeSelect: any = []
    detailEmployee: string = ''
    studentSelect: any = []
    studentList: any = []
    courseList: any = []
    courseId: string = ''
    zskStudent: any = []
    studentStatus: any = [
      {
        id: 7,
        name: '未签到'
      }, {
        id: 1,
        name: '签到'
      }, {
        id: 2,
        name: '取消预约'
      }, {
        id: 3,
        name: '学生旷课'
      }]
    agesList: any = [
      {
        id: '1',
        value: '成人'
      },
      {
        id: '2',
        value: '儿童'
      },
      {
        id: '3',
        value: '学生'
      }
    ]
    ages: string = ''

    changeStudentLevelId: string = '' // 学员等级监听id
    changeStudentId: string = '' // 约课学员等级监听id
    changedetailTeacherId: string = '' // 上课老师监听
    changeStatusId: any = [] // 状态监听
    getOrderList: any = [] // 消费记录
    signType: number = 1
    selectThemeList:any = [] // 正式课签到已选择主题
    historyList: any = []
    itemId: string = '' // id

    createRemarkMsg: any = {
      remark_type: 2,
      desc: ''
    } // 新建备注
    dialogStkShop: boolean = false
    addOccupyTitle: string = ''
    studentIds: any = [] // zsk 学员选择id
    stkReason: any = {
      desc: ''
    }
    studentRemarks: string = ''
    teacherRemark: string = ''
    addCustomer: any = {} // 正式课签到
    materialSelectList: string = '' // 正式课签到选择素材list
    studentLevelId: string = '' // 正式课选择学员等级id
    historyListArr: any = []
    teacherEmployeeId: string = ''
    course_id: string = ''
    is_teach_plan: number = 1 // 教学计划
    dialogZskSign: boolean = false
    dialogZskNoSystem: boolean = false
    getStudentLevelList: any = []
    materialSelect: any = []
    selectStudentLevel: string = ''
    // 课程记录
    value: string = ''
    // 签到记录
    historySelectlist: any = []
    signHistoryList: any = []
    signPostData: any = []
    historySignInList: any = {}
    materialList: any = []
    selectThemeHistoryList: any = []

    // 公共筛选
    instrumentTypes = []
    // teacherType = []
    campusType = []
    time: any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time:any =  ''
    end_time: any = ''
    courseType: any = []
    packetList: any = []
    courseTypeSelect: any = []
    packetSelect: any = []
    from: any = ''
    course_type: string = ''  // 1 正式课 2 试听课
    is_formal: string = '' // 1 体系 2 非体系
    studentLevelList: any = []
    levelSelect: any = []
    sign_student_level_id: any = []
    outType: boolean = true
    courseClick: boolean = false
    addnotCustomer: any = {
      teacherRemark: '',
      subject_remark: '',
      materialSelect: [],
      studentRemarks: '',
      material_remark: ''

    } // 非体系课
    total_count: number = 0
    page: number = 1
    size: number = 10
    is_sign_create = true
    selectStudentStatus: any = []
    studentItemData: any = {}
    sign_title: string = ''
    is_show_student_info: boolean = false
    student_info_id: string = ''
    isNew: boolean = true
    tableSignData: any = []
    loading: boolean = true
    is_distinct_student: string = ''

    mounted() {
      this.getStudentDetail()
      this.getStudent('')
      this.studentLevel() // 获取学员等级
      this.getCourseList()
      this.getPacketList()
    }
    getColor (type) {
      return learnStatus(type) === 'learn_color_333333' ? '' : learnStatus(type)
    }
    closeTableSign(val) {
    if(val.type) {
      val.data['id'] = this.studentItemData.id
      this.signIn(val.data)
    } else {
      this.dialogZskSign = false
    }
  }
    closeStudent(val) {
      if (val) {
        this.is_show_student_info = true
      } else {
        this.is_show_student_info = false
      }
      
    }
    getStudentDeatils(val) {
      this.student_info_id = val.student_id
      this.is_show_student_info = true
    }
    getTime(val, type) {
      return formatDate(val, type)
    }
    //  历史搜索
    async selectHistory() {
      const page_name: string = '1'
      const res: any = await CourseModule.selectHistory({page_name: page_name})
      this.ages = res.data.ages
      if (this.courseTypeSelect.length === 0) {
        if(res.data.course_type_id) {
          this.courseTypeSelect = res.data.course_type_id.split(',')
        } else {
          this.courseTypeSelect = []
        }
      }
      if(res.data.student_id) {
        this.studentIds = res.data.student_id.split(',')
        this.zskStudent = res.data.student_id.split(',')
      } else {
        this.studentIds = []
        this.zskStudent = []
      }
      if(res.data.student_level_id) {
        this.levelSelect = (res.data.student_level_id).split(',')
      } else {
        this.levelSelect = []
      }
      if (res.data.sign_student_level_id) {
        this.sign_student_level_id = (res.data.sign_student_level_id).split(',')
      } else {
        this.sign_student_level_id = []
      }
      if (res.data.sign_type) {
        const arr = res.data.sign_type.split(',')
        this.selectStudentStatus = []
        this.changeStatusId = []
        for (var i = 0;i<arr.length;i++) {
          this.selectStudentStatus.push(Number(arr[i]))
          this.changeStatusId.push(Number(arr[i]))
        }
      } else {
        this.selectStudentStatus = []
        this.changeStatusId = []
      }
      this.getStudentCourse()    // 课程记录
    }

    changeAges(val) {
      this.ages = val
      this.getStudentCourse() //  课程记录
    }

    async studentLevel() {   // 获取学员等级
      const res = await UserModule.studentLevels()
      this.studentLevelList = res.data.list  
      this.getStudentLevelList = res.data.list 
    }

    getKeyList(arr, item, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].key === val) {
          arr[i].model = item
        }
      }
    }
    getUrl() {
      this.from = this.$route.query.from
      const fromPage = this.$route.query.fromPage
      const key: any = this.$route.query.key
      const value: any = this.$route.query.value

      if(this.from) {
        // 消耗学生课时 自动勾选（签到 旷课）
        if (fromPage === 'xhxyks' || fromPage === 'xyskrs') {
          this.changeStatusId = [1, 7, 3]
          this.selectStudentStatus = [1, 7, 3]
        }
        if (fromPage === 'xyskrs') {
          this.is_distinct_student = '1'
        } else {
          this.is_distinct_student = ''
        }
        if(key === 'zhengshi' || key === 'shiting') {
          this.course_type = value
        } else if (key === 'course_type_id') {
          this.courseTypeSelect = value ? value.split(',') : []
        } else if (key === 'level_id') {
          this.outType = true
          this.levelSelect = value ? value.split(',') : []
        } else if (key === 'is_formal') {
          this.is_formal = value
        } else if (key === 'ages') {
          this.ages = value
        }
        this.getStudentCourse()    // 课程记录
        // this.selectHistory()
      } else {
        this.selectHistory()
      }
    }

    async getCourseType() {  // 获取课程种类
      const res = await UserModule.courseType()
      this.courseType = res.data.list
      this.getUrl()
    }
    async getPacketList(){
      const res = await CourseModule.packetList()
      this.packetList = res.data
    }
  
    //  子组件返回数据
    getDataChange(val){
      this.instrumentTypes = val.instrumentTypes
      this.employeeSelect = val.teacherType
      this.campusType = val.campusType
      this.time = val.time
      this.page = 1
      if (this.time.length > 0) {
        this.start_time = Date.parse(this.time[0])/1000
        this.end_time = Date.parse(this.time[1])/1000
      } else {
        this.start_time = ''
        this.end_time = ''
      }
      if(this.$route.query.from) {
        this.getStudentCourse()
      } else {
        this.selectHistory()
      }
    }

    async getCourseList(){
      // 获取course list
      const res: any = await CourseModule.getBaseCourseAll()
      if (res.code === 200){
        this.courseList = res.data
      }
    }

    async getStudentDetail() {
      const res = await CourseModule.studentDetail({ 'student_id': '' })
      this.campus_id = res.data.campus_id
      this.getSchool() // 上课老师
    }

    //学员列表查询
    async getStudent(query) {
      const res: any = await UserModule.lessStudent({ org_id: this.org_id, name: query, is_less: 1 })
      if (res.code === 200) {
        this.studentList = res.data.list
        this.loading = false
      }
    }

//  第一次签到既要回显又要展示历史签到数据
    async getSignLastList() {  // 新建
      const res: any = await CourseModule.getCourseSignList({ 'student_id': this.studentId, 'course_id': this.course_id, 'types': 'last_sign', 'org_id': this.org_id })
      if (res.code === 200) {
        this.tableSignData = res.data
        this.signHistoryList = []
        this.signHistoryList.push(res.data)
        if (this.is_teach_plan == 1) { // 体系课签到
          this.dialogZskSign = true
        } else { // 非体系课签到
          this.dialogZskNoSystem = true
        }
      }
    }
    handleCurrentChange(val) {
      this.page = val
      this.getStudentCourse()
    }
    async getStudentCourse() {
      this.changeStudentId = this.changeStudentId.toString()
      const studentIds = this.studentIds.toString()
      const p_ids = this.packetSelect.toString()
      console.log(p_ids, 'pids')
      let res: any = []
      res = await CourseModule.studentCourse({ 'course_name': this.courseId, 'student_id': studentIds,  "packet_id": p_ids, 'sign_student_level_id': this.sign_student_level_id.toString(), 'student_level_id': this.levelSelect.toString(), 'course_type_id': this.courseTypeSelect, 'teacher_id': this.employeeSelect.toString(), 'sign_type': this.changeStatusId, 'instrument_type_id': this.instrumentTypes.toString(), 'campus_id': this.campusType, 'start_time': this.start_time.toString(), 'end_time': this.end_time.toString(), is_formal:  this.is_formal, ages: this.ages, page: this.page, size: this.size, is_distinct_student: this.is_distinct_student,})
      this.studentCourseList = res.data.list
      this.total_count = res.data.total
      
    }
    // 状态监听
    changeStatus(val) {
      this.changeStatusId = val
      this.getStudentCourse()
    }

    getType(val) {
      this.is_teach_plan = val.is_teach_plan
      this.courseClick = true
      this.studentId = val.student_id
      this.itemId = val.id
      this.teacherEmployeeId = val.teacher_employee_id
      this.course_id = val.course_id
      this.getMaterial()
      this.getSignHistoryList(val)
    }

    signTypeClick(id,val) {
      if((id != 1 && val.sign_type === 1) || (id != 2 && val.sign_type === 2)) {
        return false
      }
      this.studentItemData = val
      const start = formatDate(val.start_time, 3)
      const end = formatDate(val.end_time, 4)
      this.sign_title = start+'-'+end+'的课程进行签到'
      this.is_teach_plan = val.is_teach_plan
      this.studentId = val.student_id
      this.itemId = val.id
      this.teacherEmployeeId = val.teacher_employee_id
      this.course_id = val.course_id

      if(id === val.sign_type) { // 编辑
        this.isNew = false
        if(id === 2) {
          this.signType = 2
          this.dialogStkShop = true
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为取消预约？'
          this.stkReason.desc = val.teacher_remark
        } else if (id === 3) {
          this.signType = 3
          this.dialogStkShop = true
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为学生旷课？'
          this.stkReason.desc = val.teacher_remark
        } else if (id === 1) {
          this.getType(val)
          this.is_sign_create = false
        }
      } else {  // 新建
        this.isNew = true
        if (id === 2) {
          this.signType = 2
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为取消预约？'
          this.dialogStkShop = true
        } else if (id == 3) {
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为学生旷课？'
          this.signType = 3
          this.dialogStkShop = true
        } else if (id == 1) {
          this.is_sign_create = true
          this.getMaterial()
          this.getSignLastList() //  签到记录
        }
      }
    }
    handleStkShopClose() {
      this.dialogStkShop = false
      this.dialogZskSign = false
      this.stkReason.desc = ''
      this.getStudentCourse()
    }
    // 试听课无意向到店原因提交
    handleStkShopTrue() {
      if (!this.stkReason.desc) {
        return false
      }
      let data:any = {
        teacher_remark: this.stkReason.desc,
        sign_type: this.signType,
        course_type: 1,
        id: this.itemId
      }
      this.signIn(data)
    }
    // 签到方法
    async signIn(data) {
      data.org_id = this.org_id
      const res: any = await UserModule.getClassSign(data)
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.handleStkShopClose()
        this.handleZskSignClose()
      } else {
        this.$message.error('操作失败！')
      }
    }
    // 正式课签到取消
    handleZskSignClose() {
      this.dialogZskSign = false
      this.dialogZskNoSystem = false
      this.materialSelect = []
      this.studentRemarks = ''
      this.teacherRemark = ''
      this.selectStudentLevel = ''
      this.getStudentCourse()

      this.stkReason.desc = ''
    }

    handleNotZskSignTrue(val) {
      if(val.type) {
        val.data['id'] = this.itemId
        this.signIn(val.data)
        this.dialogZskNoSystem = false
      } else {
        this.dialogZskNoSystem = false
      }
    }

    // 历史签到记录
    async getSignHistoryList(val) {  // 编辑
      const res: any = await UserModule.getCourseSignLists({ 'org_id': this.org_id, 'course_id': this.course_id, 'student_id': this.studentId, 'types': 'history_list' })
      this.historySelectlist = []
      if (res.code == 200) {

        this.tableSignData = res.data
        this.signHistoryList = []
        this.signHistoryList.push(res.data)

        if (val.is_teach_plan === 1) {
          // 体系课签到
          this.dialogZskSign = true
        } else {
          // 非体系课签到
          this.dialogZskNoSystem = true
        }
      }
    }

    // 获取素材列表
    async getMaterial() {
      const res: any = await CourseModule.getMaterial({ org_id: this.org_id, teacherEmployeeId: this.teacherEmployeeId, student_id: this.studentItemData.student_id })
      if (res.code === 200) {
        this.materialList = res.data.list
      }
    }

    // 获取教师
    async getSchool() {
      const res: any = await CourseModule.getSchoolCampus({ types: 'campus', org_id: this.org_id })
      if (res.code === 200 && res.data.list) {
        this.campus = res.data.list
        if (this.campus.length > 0) {
          for (var i = 0; i < this.campus.length; i++) {
            if (this.campus[i].campus_id === this.campus_id) {
              this.employee = this.campus[i].values
            }
          }
        }

        this.getCourseType()
      }
    }
    // 监听正式课学员列表
    changeZskStudent(val) {
      this.studentIds = val
      this.page = 1
      this.getStudentCourse()
    }
    changeZskCourse(val) {
      this.courseId = val
      this.page = 1
      this.getStudentCourse()
    }

    // 外面展示学员等级
    outStudentLevel(val) {
      this.outType = true
      this.levelSelect = val
      this.page = 1
      this.getStudentCourse()
    }
    outStudentSignLevel(val) {
      this.outType = true
      this.sign_student_level_id = val
      this.page = 1
      this.getStudentCourse()
    }
    //  课程种类
    changeCourseType(val){
      this.page = 1
      this.getStudentCourse()
    }
    // 套餐
    changePacket(val){
      this.page = 1
      this.getStudentCourse()
    }

    // 学员等级监听
    changeStudentLevel(val) {
      this.outType = false
      this.changeStudentLevelId = val
    }
    changeSelectMaterial(val) {
      let str:string = val.toString()
      this.materialSelectList = str
    }
}
